import { Fragment, useEffect, useState } from "react";
import { Link } from "react-router-dom";

export default () => {
  const [questionList, setQuestionList] = useState([]);
  useEffect(() => {
    const list = JSON.parse(sessionStorage.getItem("questionList")) || [];
    setQuestionList(list);
  }, []);

  return (
    <>
      {questionList && questionList.length > 0 ? (
        <div className="questions-container">
          {questionList.map((item, index) => (
            <Fragment key={item.id}>
              <Link to={`/question?id=${item.id}`} className="questions-every">
                {item.title}
              </Link>

              {index !== questionList.length - 1 && (
                <div className="questions-line"></div>
              )}
            </Fragment>
          ))}
        </div>
      ) : (
        <div
          style={{
            textAlign: "center",
            paddingTop: "30px",
          }}
        >
          <img style={{ width: "60%" }} src="/resources/empty.png" alt="" />
          <p>暂无数据~</p>
        </div>
      )}
    </>
  );
};
